<template>
  <div class="request-quote-container font-rubik p-3 mb-2 flex flex-col gap-3">
    <h3 class="request-quote-h3">Request a quote</h3>
    <p class="request-quote-p">Quickly tell us your needs and we will be in touch shortly</p>
    <div class="flex justify-between">
      <button class="resquest-quote-btn"
        data-vue-init="lead-flow" 
        data-props='{ "gtag": "get_quote"}'  
      >
        Get a Quote
      </button>
      <a href="/contact" class="contact-us-btn flex flex-col items-center justify-center">
        <p>Contact us</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>
.request-quote-container {
  border: 1px solid #E2E1DE;
  background-color: white;
  border-radius: 12px;
  width: 288px;
}
.request-quote-h3 {
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: -0.0125em;
  color: black;
}
.request-quote-p {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: black;
}
.resquest-quote-btn {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: -0.0125em;
  color: white;
  width: 87px;
  height: 30px;  
  background: #4D84FF;
  border-radius: 8px;
}
.contact-us-btn {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: -0.0125em;
  color: black;
}

/* mobile */
@media(max-width: 1024px) {
  .request-quote-container {
    display: none;
    /* margin-left: 20px;
    margin-right: 20px;
    width: auto; */
  }
}
</style>